import {Brick, Predicate, registerBrick} from 'olympe';
import AdminChangeLog from '../../models/adminApp/AdminChangeLog';

export default class OrPredicatesForCompanyCodes extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} query
     * @param {string[]} companyCodes
     * @param {function(*)} setQuery
     */
    update($, [query, companyCodes], [setQuery]) {
        if (Array.isArray(companyCodes) && companyCodes.length > 0) {
            setQuery(query.filter(Predicate.or(...companyCodes.map((cc) => Predicate.contains(AdminChangeLog.companyCodeProp, cc)))));
        } else {
            setQuery(query);
        }
    }
}

registerBrick('019007d98c5e606a05e6', OrPredicatesForCompanyCodes);
